export const FEATURE_SITES = '/feature/online-newsroom-software';
